module.exports = __webpack_public_path__ + "static/nintendo-c14b5c967a50d25a4c33713f71659dbc.png";